import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { Role, RolesStore } from '@fry/lib/roles';
import { RoleForm } from '@fry/components/roles/role.form';
import { FormData } from '@fry/lib/forms';
import { Observable } from 'rxjs';
import { NotifyService } from '@fry/lib/utils';


@Component({
    selector: 'app-role-add',
    templateUrl: './role-add.component.html',
    providers: [
        RoleForm
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoleAddComponent implements OnInit {

  public role: Role;
  public formData$: Observable<FormData>;

  constructor(
    private roles: RolesStore,
    private addForm: RoleForm,
    private notify: NotifyService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.role = this.roles.blank();
    this.formData$ = this.addForm.init(this.role);
  }


  onSubmit() {
    this.addForm.submit(this.role).subscribe(
      (role) => {
        this.role = role;
        this.notify.success('Role successfully added');
        this.router.navigate(['roles']);
      },
      error => {
        this.notify.error(error);
      }
    );
  }

}
